<template>
    <div>
        <div class="d-flex justify-content-end mb-3">
            <button
                class="btn btn-yokumiru-orange btn-settings"
                @click="onClickAdd">
                質問デッキを追加
            </button>
        </div>
        <div
            v-if="currentTemplate !== null"
            class="c-tab-contents">
            <div class="c-tab-contents__tabs">
                <ul v-for="template in healthSurveyTemplates"
                    class="nav nav-tabs m-tabs-line"
                    role="tablist">

                    <li class="nav-item m-tabs__item">
                        <a
                            role="tab"
                            class="nav-link m-tabs__link"
                            :class="{'active' : template.id === currentTemplate.id}"
                            @click="switchTab(template)">
                            <div class="tab-name">{{ template.name }}</div>
                        </a>
                    </li>
                </ul>
            </div>

            <div class="c-tab-contents__body tabContentBody">
                <div class="m-portlet__body">
                    <admin-health-survey-questions
                        :health-survey-template="currentTemplate">
                    </admin-health-survey-questions>
                </div>
            </div>
        </div>

        <admin-add-health-survey-template-modal/>
        <admin-edit-health-survey-template-modal/>
        <admin-delete-health-survey-template-modal/>
    </div>
</template>

<script>
import constants from '../../constants'

export default {
    data: function () {
        return {
            inProgress: false,
            currentTemplate: null,
            healthSurveyTemplates: [],
        }
    },

    created: function () {
        this.fetchHealthSurveyTemplates()
        bus.$on('health-survey-template-added', this.fetchHealthSurveyTemplates)
        bus.$on('health-survey-template-edited', this.fetchHealthSurveyTemplates)
        bus.$on('health-survey-template-deleted', this.onDeleteTemplate)
    },

    methods: {
        /**
         * メンタルチェック質問デッキ一覧取得
         */
        fetchHealthSurveyTemplates: async function () {
            if (this.inProgress) return
            this.inProgress = true

            await axios.get(constants.admin.health_survey_templates.endpoint.base)
                .then(({data}) => {
                    this.healthSurveyTemplates = data.data

                    if (this.currentTemplate === null) {
                        this.switchTab(this.healthSurveyTemplates[0])
                    }
                })

            this.inProgress = false
        },

        /**
         * 相談科タブ変更
         * @param {object} template
         */
        switchTab: function (template) {
            this.currentTemplate = template
        },

        /**
         * 質問デッキ追加ボタン押下時
         */
        onClickAdd: function () {
            bus.$emit('open-modal-admin-add-health-survey-template')
        },

        /**
         * 質問デッキ削除時
         */
        onDeleteTemplate: function () {
            this.currentTemplate = null
            this.fetchHealthSurveyTemplates()
        },
    },
}
</script>

<style scoped lang="scss">
.tab-name {
    color: #333;
    font-size: 14px;
    font-weight: bold;
}

a.active {
    .tab-name {
        color: #fff;
    }
}

.tabContentBody {
    position: relative;
    padding-bottom: 20px;
}

.questionModelTabWrapper {
    margin-left: 20%;

    .questionModelTabItem {
        padding: 0.35rem 0.75rem;
        color: #333;
        font-size: 0.875rem;
        font-weight: bold;
        text-align: center;
        line-height: 1.5;
        background: #DEDEDE;
        border: 1px solid #98A6AC;
        border-radius: 9px 9px 0 0;
        cursor: pointer;

        &.active {
            color: #fff;
            background: #07A0C3;
            border: 1px solid #07A0C3;
            cursor: default;
        }
    }
}
</style>
